export enum PAYMENT_METHODS {
  ONLINE_BANKING = 'ONLINE_BANKING',
  KASSA_24_TERMINAL = 'KASSA_24_TERMINAL',
  CARD_PAYMENT = 'CARD_PAYMENT',
  QIWI_TERMINAL = 'QIWI_TERMINAL',
  QIWI_WALLET = 'QIWI_WALLET',
  PAYMENT_BANK_DESK = 'PAYMENT_BANK_DESK'
}
